import {Button} from '@/components/ui/button/Button'
import {CheckIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {Access} from '../../types'
import {useValidateAccesses} from '../../queries/useValidateAccesses'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {toast} from '@/utilities/toast/toast'

export const ValidateAccessButton = ({
    accessesToValidate,
    onSuccess
}: {
    accessesToValidate: Access[]
    onSuccess?: () => void
}) => {
    const {t} = useTranslation()
    const {mutate: validateAccesses, isPending} = useValidateAccesses({
        onSuccess: () => {
            toast.success(t('accesses:access_validated_success', {count: accessesToValidate.length}))
            onSuccess?.()
        }
    })

    if (
        accessesToValidate.length === 0 ||
        !accessesToValidate.every(
            access =>
                access.status === 'to_validate' &&
                accessesToValidate
                    .filter(access => access.type === 'absence')
                    .every(access => access.event.communicatedOnTime != null)
        )
    )
        return null

    return (
        <Button
            variant="ghost"
            size="sm"
            disabled={isPending}
            onClick={() => validateAccesses({accessIds: accessesToValidate.map(access => access.id)})}
        >
            {isPending ? <Spinner /> : <CheckIcon />}
            {t('accesses:validate_access', {count: accessesToValidate.length})}
        </Button>
    )
}
